const Tablet01Icon = /*#__PURE__*/ [
  ["path", { d: "M14.5 2H9.5C6.67157 2 5.25736 2 4.37868 2.87868C3.5 3.75736 3.5 5.17157 3.5 8V16C3.5 18.8284 3.5 20.2426 4.37868 21.1213C5.25736 22 6.67157 22 9.5 22H14.5C17.3284 22 18.7426 22 19.6213 21.1213C20.5 20.2426 20.5 18.8284 20.5 16V8C20.5 5.17157 20.5 3.75736 19.6213 2.87868C18.7426 2 17.3284 2 14.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 19H12.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", key: "1" }]
];

export { Tablet01Icon as default };
//# sourceMappingURL=Tablet01Icon.js.map
